export const snippets = ({ pk, domain, amount, currency, ref, returnUrl, base }) => ({
  html: {
    label: "HTML / JS (widget)",
    desc: `Bouton « Payer en Bitcoin » à coller sur ${domain}. Le widget crée une session via votre clé publique (Origin vérifié) et ouvre la page de paiement dans une iframe.`,
    code: `<!-- Bouton Payer en Bitcoin — domaine autorisé : ${domain} -->
<script src="${base}/widget.js" data-public-key="${pk}"></script>

<button
  class="btc-pay-button"
  data-amount="${amount}"
  data-currency="${currency}"
  data-ref="${ref}"
  data-return-url="${returnUrl}">
  Payer en Bitcoin
</button>

<script>
  // Optionnel : écouter le résultat
  window.addEventListener('btcgateway:paid', (e) => console.log('Payé', e.detail));
  window.addEventListener('btcgateway:closed', (e) => console.log('Fermé', e.detail));
</script>`,
  },
  node: {
    label: "Node.js",
    desc: "Création de commande côté serveur avec la clé secrète (recommandé), puis redirection vers checkoutUrl.",
    code: `// npm i node-fetch (ou fetch natif Node 18+)
const GATEWAY = '${base}/api/v1';
const SECRET_KEY = process.env.BTC_GATEWAY_SECRET; // sk_test_… ou sk_live_…

async function createBitcoinOrder() {
  const res = await fetch(\`\${GATEWAY}/orders\`, {
    method: 'POST',
    headers: {
      'Authorization': \`Bearer \${SECRET_KEY}\`,
      'Content-Type': 'application/json',
      'Idempotency-Key': '${ref}-' + Date.now(),
    },
    body: JSON.stringify({
      amount: ${amount}, currency: '${currency}',
      // ou : productId: 'prod_…', quantity: 1  (le prix vient du produit, codes livrés après confirmation)
      merchantRef: '${ref}', customerEmail: 'client@example.com',
      returnUrl: '${returnUrl}',
    }),
  });
  const order = await res.json();
  // order = { orderId, checkoutUrl, address, amountBtc, expiresAt, ... }
  return order.checkoutUrl; // redirigez le client ici
}

// Vérification de la signature webhook (Express)
const crypto = require('crypto');
function verifyWebhook(req, secret) {
  const sig = Object.fromEntries(req.get('X-Gateway-Signature').split(',').map(p => p.split('=')));
  if (Math.abs(Date.now() / 1000 - Number(sig.t)) > 300) return false; // anti-rejeu 5 min
  const expected = crypto.createHmac('sha256', secret).update(\`\${sig.t}.\${req.rawBody}\`).digest('hex');
  return crypto.timingSafeEqual(Buffer.from(expected), Buffer.from(sig.v1));
}`,
  },
  php: {
    label: "PHP",
    desc: "Exemple cURL pour créer la commande et vérifier la signature du webhook.",
    code: `<?php
$gateway = '${base}/api/v1';
$secretKey = getenv('BTC_GATEWAY_SECRET'); // sk_test_… ou sk_live_…

$ch = curl_init("$gateway/orders");
curl_setopt_array($ch, [
  CURLOPT_POST => true,
  CURLOPT_RETURNTRANSFER => true,
  CURLOPT_HTTPHEADER => [
    "Authorization: Bearer $secretKey",
    "Content-Type: application/json",
    "Idempotency-Key: ${ref}-" . time(),
  ],
  CURLOPT_POSTFIELDS => json_encode([
    'amount' => ${amount}, 'currency' => '${currency}',
    'merchantRef' => '${ref}', 'returnUrl' => '${returnUrl}',
  ]),
]);
$order = json_decode(curl_exec($ch), true);
header('Location: ' . $order['checkoutUrl']);

// --- Webhook : vérification HMAC-SHA256 ---
function verifyWebhook(string $rawBody, string $header, string $secret): bool {
  parse_str(str_replace(',', '&', $header), $sig); // t=…&v1=…
  if (abs(time() - (int)$sig['t']) > 300) return false;
  $expected = hash_hmac('sha256', $sig['t'] . '.' . $rawBody, $secret);
  return hash_equals($expected, $sig['v1']);
}`,
  },
  python: {
    label: "Python",
    desc: "Exemple requests + vérification de signature (Flask/FastAPI).",
    code: `import os, time, hmac, hashlib, requests

GATEWAY = "${base}/api/v1"
SECRET_KEY = os.environ["BTC_GATEWAY_SECRET"]  # sk_test_… ou sk_live_…

def create_bitcoin_order():
    r = requests.post(f"{GATEWAY}/orders",
        headers={"Authorization": f"Bearer {SECRET_KEY}", "Idempotency-Key": f"${ref}-{int(time.time())}"},
        json={"amount": ${amount}, "currency": "${currency}", "merchantRef": "${ref}",
              "returnUrl": "${returnUrl}"})
    r.raise_for_status()
    return r.json()["checkoutUrl"]  # redirigez le client ici

def verify_webhook(raw_body: bytes, header: str, secret: str) -> bool:
    sig = dict(p.split("=") for p in header.split(","))
    if abs(time.time() - int(sig["t"])) > 300:
        return False
    expected = hmac.new(secret.encode(), f"{sig['t']}.".encode() + raw_body, hashlib.sha256).hexdigest()
    return hmac.compare_digest(expected, sig["v1"])`,
  },
});
